import React, { useEffect, useState } from "react";
import Container from "@mui/material/Container";
import { ReprintBookData } from "../../data/BookData";
import { CustomeCard } from "../../components/card/CustomCard";
import { AudioS3Card } from "../../components/card/AudioS3Card";

const BUCKET_URL = 'https://audio-discourses.s3.us-east-2.amazonaws.com/digana'
export const AudioDiscourseList = () => {
  const [files, setFiles] = useState([]);

  useEffect(() => {
    fetch(`${BUCKET_URL}/list.json`)
      .then(res => res.json())
      .then(setFiles)
      .catch(console.error);
  }, []);

  const renderList = () => {
    
    return files.map((item, index) => (
      <div
        style={{
          margin: "8px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
        key={item.title + index}
      >
        <AudioS3Card {...item} size={"sm"} bucket={BUCKET_URL} />
        {/* <img
        className="book-cover"
          src={item.image}
          alt="Gosingārāma"
        /> */}
      </div>
    ));
  };
  return (
    <Container maxWidth="lg">
      <div className="book-card-container">{renderList()}</div>
    </Container>
  );
};

const AudioDiscourses = () => {
  return (
    <div className="App">
      <div className="article">
        <h1>Audio Dhamma discourses</h1>
        <p>
          These Dhamma discourses are largely recordings from recent retreats
          that focus upon meditation practice and the Buddhist path through
          questions by the retreatants.
        </p>
      </div>
      <AudioDiscourseList />
    </div>
  );
};

export default AudioDiscourses;
